import styled from 'styled-components';

export const EmailConfirmedModalIconContainerStyled = styled.div`
  height: 48px;
  width: 48px;
  border-radius: 8px;
  background-color: var(--color-purple);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  font-size: 28px;
`;

export const EmailConfirmedModalHeaderStyled = styled.h1`
  font-size: 32px;
`;
